export const HOTNEWS = 'HOTNEWS'
